// extracted by mini-css-extract-plugin
module.exports = {"autocomplete":"quoteSearch_autocomplete__4nzRO"};